// extracted by mini-css-extract-plugin
module.exports = {"tdBody":"plan_tdBody__15ePl","table1":"plan_table1__1tGgR","tbodyTable2":"plan_tbodyTable2__13H7t"};